import { Analytics } from '@/utils/analytics';
import {
  GestureResponderEvent,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';
import { SvgProps } from 'react-native-svg';
import { TrackingData } from '@/utils/analytics/base-reporter';

const HOVER_ICON_HIT_SLOP = {
  bottom: 8,
  left: 8,
  right: 8,
  top: 8,
};

interface Props {
  accessibilityLabel: string;
  Icon: React.ComponentType<SvgProps>;
  iconProps?: Record<string, unknown>;
  onPress: (event: GestureResponderEvent) => void;
  trackingData: TrackingData;
}

export const OrderSummaryListItemHoverAction: React.FC<Props> = ({
  accessibilityLabel,
  Icon,
  iconProps,
  onPress,
  trackingData,
}) => {
  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      hitSlop={HOVER_ICON_HIT_SLOP}
      onPress={(event) => {
        if (trackingData) {
          Analytics.track(trackingData.name, trackingData.properties);
        }

        onPress(event);
      }}
      style={styles.base}
    >
      <Icon height={18} width={18} {...iconProps} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
  },
});
